import { render, staticRenderFns } from "./blueDeal.vue?vue&type=template&id=8c5dc3fa&scoped=true"
import script from "./blueDeal.vue?vue&type=script&lang=js"
export * from "./blueDeal.vue?vue&type=script&lang=js"
import style0 from "./blueDeal.vue?vue&type=style&index=0&id=8c5dc3fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5dc3fa",
  null
  
)

export default component.exports